module.exports = __webpack_public_path__ + "static/img/img.11a95389.jpg";